import React, { useMemo, useState } from "react";
import { userService } from "@/services";
import { formatEmail, isValidEmail } from "@/utils";
import "./ForgotPassword.css";

const ForgotPasswordScreen: React.FC = () => {
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);

  const error = useMemo(() => {
    const value = formatEmail(email);

    if (!touched) return null;
    if (value.length === 0) return "Informe seu e-mail.";
    if (!isValidEmail(value)) return "E-mail inválido (ex: nome@dominio.com).";

    return null;
  }, [email, touched]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setTouched(true);
    setSubmitError(null);
    setSubmitMessage(null);

    const value = formatEmail(email);
    if (value.length === 0 || !isValidEmail(value)) return;

    setIsSubmitting(true);

    try {
      const result = await userService.resetPassword(value);

      if (result.success) {
        setSubmitMessage(
          "Se existir uma conta com esse e-mail, enviamos um link de redefinição.",
        );
      } else {
        setSubmitError(result.error.detail ?? result.error.title);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="stats">
      <div className="container">
        <div className="stat-card cta-content center auth-card">
          <h1 className="auth-title">Esqueci minha senha</h1>
          <p className="auth-subtitle">
            Informe seu e-mail para receber o link de redefinição.
          </p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div>
              <input
                name="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(formatEmail(e.target.value));
                  setSubmitError(null);
                  setSubmitMessage(null);
                }}
                onBlur={() => setTouched(true)}
                placeholder="E-mail"
                autoComplete="email"
                inputMode="email"
                aria-invalid={Boolean(error)}
                aria-describedby={error ? "email-error" : undefined}
              />
              {error ? (
                <div id="email-error" className="form-error">
                  {error}
                </div>
              ) : null}
            </div>

            <div className="auth-actions">
              <button
                className="btn-primary"
                type="submit"
                disabled={isSubmitting || Boolean(error)}
              >
                {isSubmitting ? "Enviando..." : "Enviar link"}
              </button>

              <div className="links ">
                <a href="/login">Voltar para o login</a>
              </div>

              {submitError ? (
                <div className="form-error form-message">{submitError}</div>
              ) : null}
              {submitMessage ? (
                <div className="form-message">{submitMessage}</div>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordScreen;
